import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";
import { EAuthRoles } from "src/core/auth/entities";
import { ApiClientFactory } from "@delanobgt/admin-core/util/types";

import { ERetailRevenueSortField, IRetailRevenue, PRetailRevenueFilter } from "../entities";
import IRetailRevenueRepository from "../repository";

export default class RetailRevenueRepository implements IRetailRevenueRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private RETAIL_REVENUE_ROUTE_FOR_RETAIL = "/retail/retail-revenue";
  private RETAIL_REVENUE_ROUTE_FOR_ADMIN = "/admin/retail-revenue";
  private RETAIL_REVENUE_ROUTE_BY_ROLE = {
    [EAuthRoles.ADMIN]: this.RETAIL_REVENUE_ROUTE_FOR_ADMIN,
    [EAuthRoles.RETAIL]: this.RETAIL_REVENUE_ROUTE_FOR_RETAIL,
  };

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  private buildFilter(filter: PRetailRevenueFilter) {
    const created_at = filter.created_at_enabled ? `${filter.created_at_start},${filter.created_at_end}` : undefined;

    const clonedFilter = { ...filter };
    delete clonedFilter.created_at_enabled;
    delete clonedFilter.created_at_start;
    delete clonedFilter.created_at_end;

    return {
      ...clonedFilter,
      created_at,
    };
  }

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: unknown) {
    return _.get(error, "response.data.errors", "Something went wrong!");
  }

  async getRetailRevenue(
    role: EAuthRoles,
    pagination: IPagination,
    filter: PRetailRevenueFilter,
    sorts: ISort<ERetailRevenueSortField>[],
    signal?: CancelTokenSource,
  ): Promise<[IRetailRevenue[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      (val) => val,
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.RETAIL_REVENUE_ROUTE_BY_ROLE[role]}?sort=${sort}`,
        {
          params,
        },
      ),
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }
}
